import { useEffect } from 'react';
import { useApp } from '../../contexts/AppContext';
import { useTenant } from '../../contexts/TenantContext';

const PAGE_LABELS = {
  dashboard:  { icon: '📊', label: 'Dashboard'        },
  assets:     { icon: '📦', label: 'Assets'            },
  facilities: { icon: '🏭', label: 'Facilities'        },
  checkout:   { icon: '🔄', label: 'Asset Checkout'    },
  requests:   { icon: '📋', label: 'Transfer Requests' },
  deliveries: { icon: '🚚', label: 'Deliveries'        },
  tracking:   { icon: '📡', label: 'Live Tracking'     },
  reports:    { icon: '📈', label: 'Reports'            },
  users:      { icon: '👥', label: 'User Management'   },
  settings:   { icon: '⚙',  label: 'System Settings'  },
};

export default function Header({ page, onMenuClick }) {
  const { reload } = useApp();
  const { org }    = useTenant();

  // Use org name as system name; cache so LoginPage can read it before auth
  const companyName = org?.name || '';
  const systemName  = org?.system_name || companyName;
  if (companyName) localStorage.setItem('rfid_wms_company', companyName);
  if (systemName)  localStorage.setItem('rfid_wms_system_name', systemName);

  const { icon, label } = PAGE_LABELS[page] || { icon: '📄', label: page };
  const now = new Date().toLocaleString('en-MY', {
    weekday: 'short', day: 'numeric', month: 'short',
    hour: '2-digit', minute: '2-digit',
  });

  // Update browser tab title
  useEffect(() => {
    document.title = companyName
      ? `${label} — ${companyName}`
      : label;
  }, [page, companyName, label]);

  return (
    <header style={{
      height: 58, flexShrink: 0,
      borderBottom: '1px solid #1a2a3a',
      display: 'flex', alignItems: 'center',
      padding: '0 16px', gap: 12, background: '#0a0f16',
    }}>
      {/* Hamburger — hidden on desktop via CSS */}
      <button
        className="hamburger-btn"
        onClick={onMenuClick}
        style={{
          background: 'none', border: '1px solid #1a2a3a', borderRadius: 7,
          color: '#607080', fontSize: 18, cursor: 'pointer',
          padding: '5px 10px', lineHeight: 1, flexShrink: 0,
        }}
      >☰</button>

      <span style={{ fontSize: 18 }}>{icon}</span>
      <div style={{ fontFamily: "'Syne',sans-serif", fontWeight: 800, fontSize: 15, color: '#e8edf2', whiteSpace: 'nowrap' }}>
        {label}
      </div>

      {/* Company name pill */}
      {companyName && (
        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }} className="header-orgname">
          <div style={{ width: 1, height: 18, background: '#1a2a3a' }} />
          <div style={{
            fontSize: 12, fontFamily: "'Syne',sans-serif", fontWeight: 700,
            color: '#00e5a0', background: 'rgba(0,229,160,.08)',
            border: '1px solid rgba(0,229,160,.15)', borderRadius: 6,
            padding: '3px 10px', whiteSpace: 'nowrap',
          }}>
            {companyName}
          </div>
        </div>
      )}

      <div style={{ flex: 1 }} />

      <div className="header-clock" style={{ fontSize: 11, color: '#3a5060', fontFamily: "'IBM Plex Mono',monospace", whiteSpace: 'nowrap' }}>
        {now}
      </div>
      <button
        onClick={reload}
        title="Refresh all data"
        style={{
          background: 'none', border: '1px solid #1a2a3a', borderRadius: 7,
          color: '#607080', fontSize: 14, cursor: 'pointer',
          padding: '5px 10px', transition: 'all 0.15s', flexShrink: 0,
        }}
        onMouseEnter={e => e.currentTarget.style.borderColor = '#00e5a040'}
        onMouseLeave={e => e.currentTarget.style.borderColor = '#1a2a3a'}
      >↻</button>
    </header>
  );
}
